import React from "react";
import PropTypes from "prop-types";
import TextInput from "components/v3/text-input/TextInput";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import styles from "./styles.module.scss";

class AddUsers extends React.Component {
    constructor(props) {
        super(props);

        this._onEmailChange = this._onEmailChange.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onEmailChange(event) {
        this.props.onEmailChange(event.target.value.trim());
    }

    _onSubmit(event) {
        event.preventDefault();
        event.target.focus();
        this.props.onAddUser();
    }

    render() {
        const {
            errors,
            maxUsersCount,
            users,
            email
        } = this.props;

        const addUserButtonDisabled = !email || !!errors["maxUsersReached"] || !!errors["email"];

        return (
            <div className={ styles.addUsers }>
                <div className={ styles.title }>Add user</div>
                <div className={ styles.seats }>{ users.length }/{ maxUsersCount } seats used</div>
                <AddUser
                    email={ email }
                    errors={ errors }
                    buttonDisabled={ addUserButtonDisabled }
                    onChange={ this._onEmailChange }
                    onSubmit={ this._onSubmit }
                />
            </div>
        );
    }
}

const AddUser = ({ email, errors, onChange, onSubmit, buttonDisabled }) => {
    return (
        <form className={ styles.addUser } onSubmit={ onSubmit }>
            <ErrorHandler types={ ["addUser", "email"] } errors={ errors }>
                <TextInput
                    name="email"
                    value={ email }
                    placeholder="Enter user's email address"
                    onChange={ onChange }
                />
            </ErrorHandler>
            <div className={ styles.addUserButton }>
                <PrimaryButton
                    text="Add User"
                    disabled={ buttonDisabled }
                />
            </div>
        </form>
    );
};

AddUsers.propTypes = {
    errors: PropTypes.object,
    maxUsersCount: PropTypes.number,
    users: PropTypes.array,
    email: PropTypes.string,
    onAddUser: PropTypes.func.isRequired,
    onEmailChange: PropTypes.func.isRequired
};

export default AddUsers;
